import React from 'react';

interface SummaryCardsSkeletonProps {
  count?: number;
}

const SummaryCardsSkeleton: React.FC<SummaryCardsSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm p-6 border border-gray-100 dark:border-gray-700 relative overflow-hidden"
        >
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-2 shimmer"></div>
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-32 shimmer"></div>
          
          <style>{`
            @keyframes shimmer {
              0% {
                background-position: -1000px 0;
              }
              100% {
                background-position: 1000px 0;
              }
            }
            
            .shimmer {
              background: linear-gradient(
                90deg,
                #f0f0f0 0%,
                #e0e0e0 20%,
                #f0f0f0 40%,
                #f0f0f0 100%
              );
              background-size: 1000px 100%;
              animation: shimmer 2s infinite linear;
            }
            
            .dark .shimmer {
              background: linear-gradient(
                90deg,
                #374151 0%,
                #4b5563 20%,
                #374151 40%,
                #374151 100%
              );
              background-size: 1000px 100%;
              animation: shimmer 2s infinite linear;
            }
          `}</style>
        </div>
      ))}
    </div>
  );
};

export default SummaryCardsSkeleton;

